export default "__VITE_ASSET__C4yAw62w__"